'use client'

import { useEffect, useState } from 'react'

import { useMaestroSession } from '@maestro/commerce-blocks/providers/maestro-session/maestro-session.context'

export const useSessionReady = () => {
  const { session } = useMaestroSession()
  const [isSessionReady, setIsSessionReady] = useState(false)

  useEffect(() => {
    if (session !== undefined) {
      setIsSessionReady(true)
    }
  }, [session])

  return isSessionReady
}
